module.exports = __webpack_public_path__ + "img/casa.416456d2.svg";